import { useEffect, useState } from "react";
import {
  CommonCodeGroupType,
  useGetCommonCodeGroupsByTypeAsAdminQuery,
} from "../../../lib/apollo/graphql/generated";
import Input from "../../common/components/Input";
import SelectBox from "../../common/components/SelectBox";

interface LinkTypeInputProps {
  link: string;
  typeId: string;
  onTypeSelect: (typeId: string) => void;
  onUrlChange: (url: string) => void;
}

export default function LinkTypeInput({
  link,
  typeId,
  onTypeSelect,
  onUrlChange,
}: LinkTypeInputProps) {
  const { data } = useGetCommonCodeGroupsByTypeAsAdminQuery({
    variables: {
      types: [CommonCodeGroupType.BannerLinkType],
    },
  });

  const linkTypeCodes =
    data?.getCommonCodeGroupsByTypeAsAdmin?.filter(
      (item) => item.groupCode === CommonCodeGroupType.BannerLinkType
    )[0].activeCommonCodes || [];

  const linkTypeOptions = linkTypeCodes.map((code) => ({
    value: code.id,
    label: code.name,
  }));

  const [isDisabled, setIsDisabled] = useState(true);

  useEffect(() => {
    const optionById = linkTypeOptions.find(
      (option) => option.value === typeId
    );

    if (optionById?.label === "링크 없음" || !typeId) {
      setIsDisabled(true);
      onUrlChange("");
    } else {
      setIsDisabled(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [typeId]);

  return (
    <div className="flex flex-col gap-1">
      <SelectBox
        label="링크"
        value={typeId}
        onSelect={onTypeSelect}
        options={linkTypeOptions}
        className="h-[50px]"
      />
      <Input
        placeholder="링크 URL"
        disabled={isDisabled}
        value={link}
        onValueChange={onUrlChange}
      />
    </div>
  );
}
